import { render } from "./TicketsRegistrationAdd.vue?vue&type=template&id=1d5ad57c&ts=true&lang=pug"
import script from "./TicketsRegistrationAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsRegistrationAdd.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__